import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import i18n from "./i18n";
import filters from "./filters/global-filters";
import moment from "moment";

Vue.config.productionTip = false;

const locale = localStorage.getItem("locale");
localStorage.setItem("locale", locale ? locale : "en");

moment.locale(locale ? locale : "en");

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
